import { ChangeEvent, useCallback, useMemo } from "react";
import { Input } from "reactstrap";
import { SapParameterValueTypes } from "./SapParameterValueTypeOption";
import { customerFields, productTypeFields } from "../../../../../../backoffice/dtos/groups/DepartmentSapParameter";
import { useTranslation } from "react-i18next";

export interface Option {
    value: string;
    label: string;
}

export const sapParameterCustomerValueTypesOptions: Option[]
    = [
        {
            value: "",
            label: ""
        },
        ...customerFields.map(m => ({value: m, label: m}))
    ]

export const sapParameterProductTypeValueTypesOptions: Option[]
    = [
        {
            value: "",
            label: ""
        },
        ...productTypeFields.map(m => ({value: m, label: m}))
    ]

export default function SapParameterInputType(
    {
        label,
        value,
        valueType,
        onValueChange
    }: {
        label: string;
        value: string;
        valueType: string;
        onValueChange: (label: string, value: string) => void;
    }
): JSX.Element {
    const { t } = useTranslation("department_info")

    const options: Option[] = useMemo(() => {
        switch(valueType) {
            case "Customer":
                return sapParameterCustomerValueTypesOptions;
            case "ProductType":
                return sapParameterProductTypeValueTypesOptions;
            default:
                return [];
        }
    }, [valueType]);

    const setValue = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        onValueChange(e.target.name, e.target.value)
    }, [onValueChange]);

    switch(valueType) {
        case "Fixed":
            return (
                <Input type="text" id={label} name={label} onChange={setValue} value={value} />
            );
        case "Customer":
            return (
                <Input type="select" id={label} name={label} onChange={setValue} value={value}>
                    {
                        options.map(m => (
                            <option value={m.value}>{t(m.label)}</option>
                        ))
                    }
                </Input>
            );
        case "ProductType":
            return (
                <Input type="select" id={label} name={label} onChange={setValue} value={value}>
                    {
                        options.map(m => (
                            <option value={m.value}>{t(m.label)}</option>
                        ))
                    }
                </Input>
            );
        default:
            return (
                <></>
            );
    }
}